module.exports = __webpack_public_path__ + "static/media/rizee_logo.fa1e359c.png";